import apiHttpRequest from "services/api-http-request";

const listContainerSensors = async () => {
  let sensors = [];

  try {
    sensors = await apiHttpRequest.get('/container/sensors');
  } catch (e) {
    console.error(e);
  }

  return sensors;
}

const getContainerSensorDetail = async (sensorType, startTime, endTime) => {
  const params = {};

  if (startTime && startTime.length > 0) {
    params.start_time = startTime
  }

  if (endTime && endTime.length > 0) {
    params.end_time = endTime;
  }

  let detail = {};

  try {
    detail = await apiHttpRequest.get(`/container/sensors/${sensorType}`, params);
  } catch (e) {
    console.error(e);
  }

  return detail
}

export default {
  listContainerSensors,
  getContainerSensorDetail
}